import { EvaCompany, EvaFeatures } from "./internal";

export enum IndexConfigObjectTemporalReference {
  "YY" = "YY",
  "YYMM" = "YYMM",
  "YYYY" = "YYYY",
  "YYYYMM" = "YYYYMM",
  "YYYY-MM" = "YYYY-MM",
  "MMYYYY" = "MMYYYY",
  "YYYYMMDD" = "YYYYMMDD",
  "YYMMDD" = "YYMMDD",
  "YYYY-MMDD" = "YYYY-MMDD",
  "none" = "",
}
export enum IndexConfigObjectSeparator {
  "dash" = "-",
  "dot" = ".",
  "slash" = "/",
  "underscore" = "_",
  "none" = "",
}
export enum IndexConfigObjectSeparatorPosition {
  AFTER_PREFIX = "AFTER_PREFIX",
  AFTER_TEMPORAL = "AFTER_TEMPORAL",
  NONE = "NONE",
  BOTH = "BOTH",
}

export enum IndexObjectType {
  OFFER = "OFFER",
  PROJECT = "PROJECT",
  CUSTOMER = "CUSTOMER",
  SUPPLIER = "SUPPLIER",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  WORKSHOP = "WORKSHOP",
  ISSUED_INVOICE = "ISSUED_INVOICE",
  CONTACT = "CONTACT",
  OFFER_TEMPLATE = "OFFER_TEMPLATE",
  CALL_TO_TENDER = "CALL_TO_TENDER",
  CONTRACT = "CONTRACT",
  INTERVENTION = "INTERVENTION",
  EXPENSE_REPORT = "EXPENSE_REPORT",
  CUSTOM_ARTICLE = "CUSTOM_ARTICLE",
}

export enum IndexObjectTypeLabel {
  OFFER = "offre",
  PROJECT = "chantier",
  CUSTOMER = "client",
  SUPPLIER = "fournisseur",
  PURCHASE_ORDER = "bon de commande",
  WORKSHOP = "atelier",
  ISSUED_INVOICE = "facture",
  CONTACT = "contact",
  OFFER_TEMPLATE = "modèle d'offre",
  CALL_TO_TENDER = "appel d'offres",
  CONTRACT = "contrat",
  INTERVENTION = "intervention",
  EXPENSE_REPORT = "note de frais",
  CUSTOM_ARTICLE = "article",
}
export class IndexConfigObject {
  index_config_id: string;
  eva_company_id: string;
  object_type: IndexObjectType = IndexObjectType.OFFER;
  prefix: string;
  temporal_reference: IndexConfigObjectTemporalReference = IndexConfigObjectTemporalReference.YY;
  separator: IndexConfigObjectSeparator = IndexConfigObjectSeparator.dash;
  separator_position: IndexConfigObjectSeparatorPosition = IndexConfigObjectSeparatorPosition.BOTH;
  start_number = 1;
  number_length = 3;

  // External

  current_counter: number;

  get exampleNumber(): string {
    return this.generateFullId(new Date(), this.start_number);
  }

  constructor() {}

  public static createInstance(jsonData: any): IndexConfigObject {
    const v = Object.assign(new IndexConfigObject(), jsonData);

    return v;
  }

  public static createInstances(jsonData: any[]): IndexConfigObject[] {
    return jsonData.map((e) => IndexConfigObject.createInstance(e));
  }

  public static createDate(format: string, date?: Date): string {
    const d = date ?? new Date();

    let temporal = format.replace("YYYY", d.getFullYear().toString());
    temporal = temporal.replace("YY", d.getFullYear().toString().slice(-2));
    temporal = temporal.replace("MM", (d.getMonth() + 1).toString().padStart(2, "0"));
    temporal = temporal.replace("DD", d.getDate().toString().padStart(2, "0"));

    return temporal;
  }

  public generateObjectPrefix(date: Date): string {
    const datePart = IndexConfigObject.createDate(this.temporal_reference, date);
    const sep = this.separator ?? IndexConfigObjectSeparator.dash;
    let prefix = "";

    if (this.prefix) {
      prefix += this.prefix;
      if (
        this.separator_position === IndexConfigObjectSeparatorPosition.AFTER_PREFIX ||
        this.separator_position === IndexConfigObjectSeparatorPosition.BOTH
      ) {
        prefix += sep;
      }
    }
    if (datePart) {
      prefix += datePart;
    }

    return prefix;
  }

  public generateFullId(date: Date, counter: number): string {
    const prefix = this.generateObjectPrefix(date);
    const counterFormatted = counter.toString().padStart(this.number_length, "0");
    let sepAfterTemp = this.separator ?? IndexConfigObjectSeparator.dash;
    if (
      this.temporal_reference === IndexConfigObjectTemporalReference.none ||
      (this.separator_position !== IndexConfigObjectSeparatorPosition.AFTER_TEMPORAL &&
        this.separator_position !== IndexConfigObjectSeparatorPosition.BOTH)
    ) {
      sepAfterTemp = IndexConfigObjectSeparator.none;
    }

    const fullId = prefix ? `${prefix}${sepAfterTemp}${counterFormatted}` : counterFormatted;
    return fullId;
  }

  public doesCompanyHaveFeature(evaCompany: EvaCompany): boolean {
    if (this.object_type === IndexObjectType.CUSTOM_ARTICLE) {
      return evaCompany.hasFeature(EvaFeatures.CATALOG);
    }
    if (this.object_type === IndexObjectType.CONTRACT) {
      return evaCompany.hasFeature(EvaFeatures.MAINTENANCE_CONTRACT);
    }
    if (this.object_type === IndexObjectType.INTERVENTION) {
      return evaCompany.hasFeature(EvaFeatures.MAINTENANCE_CONTRACT);
    }
    if (this.object_type === IndexObjectType.EXPENSE_REPORT) {
      return evaCompany.hasFeature(EvaFeatures.EXPENSE_REPORT);
    }
    return true;
  }
}
